import { render, staticRenderFns } from "./paramSetup.vue?vue&type=template&id=43ae89d7&scoped=true&"
import script from "./paramSetup.vue?vue&type=script&lang=js&"
export * from "./paramSetup.vue?vue&type=script&lang=js&"
import style0 from "./paramSetup.vue?vue&type=style&index=0&id=43ae89d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae89d7",
  null
  
)

export default component.exports